export { default } from "./setPassword";
